import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";

window.$ = window.jQuery = require("jquery");

export default {
    name: "ProfesionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "ProfesionPage",
            ss: ss,
            ajax: {
                "url": ss.indexProfesion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Profesion', name: 'Profesion', title: 'Profesion' },
                { data: 'Abreviatura', name: 'Abreviatura', title: 'Abreviatura' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                }, 
            ],

            profesion:{},
            profesiones: [],
            isLoading: false,
            errorBag: {},
            auth : null,
        };
    },
    methods: {
        newProfesion() {
            this.profesion = {};
            this.$refs['frm-profesion'].show();
        },
     
        editProfesion(id){
            this.profesion = {};
            this.ss.showProfesion(id)
            .then((result) => {
              let response = result.data;
              this.profesion = response.data[0];
              this.$refs['frm-profesion'].show();
            })
            .catch(error => {
              console.log(error);
              this.isLoading = false;
            });
        },

        showProfesion(id) {
            this.profesion = {};
            this.isLoading = true;
            this.ss.showProfesion(id)
              .then((result) => {
                let response = result.data;
                this.profesion = response.data[0];
                this.$refs['view-profesion'].show();
                this.isLoading = false;
              })
              .catch(error => {
                console.log(error);
                this.isLoading = false;
              });
        },

        cancelShowProfesion(){
            this.profesion = {};
            this.$refs['view-profesion'].hide();
        },

      
        cancelStoreProfesion() {
            this.profesion = {};
            this.$refs['frm-profesion'].hide();
        },
        saveProfesion() {
            this.ss.storeProfesion(this.profesion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    this.$refs['frm-profesion'].hide();
                    this.$refs['datatable-Profesion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        
        deleteProfesion(id) {

            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "Esta acción es irreversible.",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttons: true,
                dangerMode: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.ss.deleteProfesion({ id: id })  
                        .then((result) => {
                            let response = result.data;
                            console.log(response);
                            this.$bvToast.toast(
                                response.msg, 
                                {
                                    title: 'Correcto',
                                    variant: 'success',
                                    autoHideDelay: 5000
                                }
                            )
                            this.$refs['datatable-Profesion'].reload();
                        })
                        .catch(error => {
                            console.log(error);
                        })
                } else {
                    // No hacer nada si el usuario cancela la eliminación
                }
            });
        },
        
        
        draw() {
            window.$('.btn-datatable-Profesion').on('click', (evt) => {
                const buttonId = window.$(evt.target).closest('button').attr('id'); 
                
                if (buttonId.includes('details_')) {
                    const id = buttonId.replace('details_', ''); 
                    this.showProfesion(id);
                } 
                else if (buttonId.includes('edit_')) {
                    const id = buttonId.replace('edit_', ''); 
                    this.editProfesion(id);
                } 
                else if (buttonId.includes('delete_')) {
                    const id = buttonId.replace('delete_', ''); 
                    this.deleteProfesion(id);
                }
            });
        }
    },
    components: {
        dataTable,
     
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }else{
            this.auth = persona;
        }
    }
};
